module.exports = __webpack_public_path__ + "img/toggle-02-right.cc6a36a4.svg";